<div class="sales-dashboard-container">
  <!-- Header Section -->
  <div class="sales-header">
    <div class="header-left">
      <div class="header-title">
        <h1>Sales & Reports</h1>
        <p>Monitor your sales performance and generate insights</p>
      </div>
    </div>
    
    <div class="header-right">
      <div class="header-controls">
                 <div class="dropdown-group">
           <div class="dropdown-wrapper">
             <label class="dropdown-label">Store</label>
             <div class="dropdown">
               <div class="dropdown-trigger" (click)="isDropDown.set(!isDropDown())">
                 <i class="fa fa-store" aria-hidden="true"></i>
                 <span>{{ changedStoreName }}</span>
                 <span class="dropdown-arrow">▼</span>
               </div>
               <div class="dropdown-menu" [class]="isDropDown() ? 'active' : ''">
                 <ul>
                   <li *ngFor="let names of storeNames" class="dropdown-item" (click)="onStoreNameChange(names.id, names.name)">
                     {{ names.name }}
                   </li>
                 </ul>
               </div>
             </div>
           </div>
           <div class="dropdown-wrapper">
             <label class="dropdown-label">Date</label>
             <div class="dropdown">
               <div class="dropdown-trigger" (click)="isDropDownPeriod.set(!isDropDownPeriod())">
                 <span>{{ changedStorePeriod }}</span>
                 <span class="dropdown-arrow">▼</span>
               </div>
               <div class="dropdown-menu" [class]="isDropDownPeriod() ? 'active' : ''">
                 <ul>
                   <li *ngFor="let period of period" class="dropdown-item" (click)="onStorePeriodChange(period)">
                     {{ period.period }}
                   </li>
                 </ul>
               </div>
             </div>
           </div>
         </div>
      </div>
    </div>
  </div>



  <!-- Metrics Cards Section -->
  <div class="metrics-section">
    <div class="metrics-grid">
      <!-- Stock Sales Order -->
      <div class="metric-card sales-order" (dblclick)="navigateToDetailPage(currentStoreId, 'sales_order', 'Stock Sales Order', changedStorePeriod)">
        <div class="metric-icon">
          <img src="../../../../assets/images/storelist/implants.svg" alt="sales order">
        </div>
                 <div class="metric-content">
           <div class="metric-title">Stock Sales Order</div>
           <div class="metric-value">{{storeDetails.sales_order || 0}}</div>
         </div>
      </div>

      <!-- Consumed Implants -->
      <div class="metric-card consumed" (dblclick)="navigateToDetailPage(currentStoreId, 'consumed', 'Consumed Implants', changedStorePeriod)">
        <div class="metric-icon">
          <img src="../../../../assets/images/storelist/consumed.svg" alt="consumed">
        </div>
                 <div class="metric-content">
           <div class="metric-title">Consumed Implants</div>
           <div class="metric-value">{{storeDetails.consumed || 0}}</div>
         </div>
      </div>

      <!-- Missing Implants -->
      <div class="metric-card missing" (dblclick)="navigateToDetailPage(currentStoreId, 'missing','Missing Implants', changedStorePeriod)">
        <div class="metric-icon">
          <img src="../../../../assets/images/storelist/missingstock.svg" alt="missing">
        </div>
                 <div class="metric-content">
           <div class="metric-title">Missing Implants</div>
           <div class="metric-value">{{storeDetails.missing || 0}}</div>
         </div>
      </div>

      <!-- Expired Implants -->
      <div class="metric-card expired" (dblclick)="navigateToDetailPage(currentStoreId, 'expired', 'Expired Implants', changedStorePeriod)">
        <div class="metric-icon">
          <img src="../../../../assets/images/storelist/expired.svg" alt="expired">
        </div>
                 <div class="metric-content">
           <div class="metric-title">Expired Implants</div>
           <div class="metric-value">{{storeDetails.expired || 0}}</div>
         </div>
      </div>

      <!-- Transferred Stock -->
      <div class="metric-card transferred" (dblclick)="navigateToDetailPage(currentStoreId, 'transferred','Transferred Stock', changedStorePeriod)">
        <div class="metric-icon">
          <img src="../../../../assets/images/storelist/transferred.svg" alt="transferred">
        </div>
                 <div class="metric-content">
           <div class="metric-title">Transferred Stock</div>
           <div class="metric-value">{{storeDetails.transferred || 0}}</div>
         </div>
      </div>
    </div>
  </div>

  <!-- Custom Reports Section -->
  <div class="custom-reports-section">
    <div class="custom-reports-card">
      <div class="custom-reports-content">
        <div class="custom-reports-icon">
          <img src="../../../../assets/images/storelist/customIcon.svg" alt="custom reports">
        </div>
        <div class="custom-reports-info">
          <h3>Need Custom Reports?</h3>
          <p>Use our custom reports option to generate detailed insights tailored to your needs</p>
          <button class="custom-reports-btn" (click)="navigateToReportPage()">
            <i class="fa fa-chart-bar" aria-hidden="true"></i>
            Generate Custom Reports
          </button>
        </div>
      </div>
    </div>
  </div>
</div>